var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.969,
    height: 22.969,
    viewBox: "0 0 22.969 22.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Distribution",
    transform: "translate(-224 -499.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "distribution-center",
    d: "M19.161,11.651l-2.142,1.237,6.946,4.01V19.87a.316.316,0,0,1-.162.28l-1.61.93a.162.162,0,0,1-.243-.14V18.061L15,14.051l-2.142,1.237a.632.632,0,0,0-.323.56v7.274a.632.632,0,0,0,.323.56l6.3,3.637a.632.632,0,0,0,.647,0l6.3-3.637a.632.632,0,0,0,.323-.56V15.848a.632.632,0,0,0-.323-.56l-6.3-3.637a.632.632,0,0,0-.647,0ZM30.968,30.771a.183.183,0,0,1-.2.2L26.9,30.652a.183.183,0,0,1-.114-.311l.829-.829-1.879-1.879a.366.366,0,0,1,0-.517l1.384-1.384a.366.366,0,0,1,.517,0l1.879,1.879.829-.829a.183.183,0,0,1,.311.114Zm0-22.573-.316,3.875a.183.183,0,0,1-.311.114l-.829-.829-1.879,1.879a.366.366,0,0,1-.517,0l-1.384-1.384a.366.366,0,0,1,0-.517L27.61,9.458l-.829-.829a.183.183,0,0,1,.114-.311L30.771,8a.183.183,0,0,1,.2.2ZM8,8.2A.183.183,0,0,1,8.2,8l3.875.316a.183.183,0,0,1,.114.311l-.829.829,1.879,1.879a.366.366,0,0,1,0,.517l-1.384,1.384a.366.366,0,0,1-.517,0L9.457,11.359l-.829.829a.183.183,0,0,1-.311-.114ZM8,30.771,8.317,26.9a.183.183,0,0,1,.311-.114l.829.829,1.879-1.879a.366.366,0,0,1,.517,0l1.384,1.384a.366.366,0,0,1,0,.517l-1.879,1.879.829.829a.183.183,0,0,1-.114.311L8.2,30.968a.183.183,0,0,1-.2-.2ZM13.612,18.16a.258.258,0,1,1,.259-.447L16.957,19.5a.258.258,0,1,1-.259.447Zm0,1.421a.258.258,0,1,1,.259-.447l1.543.891a.258.258,0,0,1-.259.447Z",
    transform: "translate(216 491.33)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution);
export default __webpack_public_path__ + "static/media/distribution.b1ec29a8d68d30901e2bc4619d179642.svg";
export { ForwardRef as ReactComponent };